import {
  Button,
  TextField,
  Box,
  Grid,
  CssBaseline,
  Typography,
  CardMedia,
  Link,
} from "@mui/material";
import logo from "../../assets/logo.png";
import background from "../../assets/login_background.png";
import { useState } from "react";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { purpleCTA } from "../../components/ColorDefs";
import { forgotPasswordRequest } from "../../api/authentication/password/PasswordAPI";
import { OptionsObject, useSnackbar } from "notistack";
import {
  AlertErrorProp,
  AlertSuccessProp,
} from "../../components/SnackbarNoti";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import { GOOGLE_CAPTCHA_ID } from "../../api/DefaultConfig";

const theme = createTheme();
function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://trendz.vn/">
        trendz.vn
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
function ForgotPasswordPage() {
  const { t } = useTranslation(["common", "account"]);
  const [email, setEmail] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [enableSubmit, setEnableSubmit] = useState(
    window.location.toString().startsWith("https://trendz.vn") ? false : true
  );
  function onCaptchaDone() {
    setEnableSubmit(true);
  }
  const handleSubmit = (e: any) => {
    e.preventDefault();
    forgotPasswordRequest(email)
      .then((res) => {
        enqueueSnackbar(
          "Please check your email",
          AlertSuccessProp as OptionsObject
        );
      })
      .catch((err) => {
        enqueueSnackbar(
          "The server or your Internet connection is temporary down",
          AlertErrorProp as OptionsObject
        );
      });
  };
  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }} className="fadein">
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${background})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 24,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "absolute",
            }}
          >
            <Link href="/">
              <CardMedia
                image={logo}
                sx={{
                  mx: 2,
                  width: "250px",
                  height: "60px",
                  marginBottom: "20px",
                }}
              />
            </Link>

            <Typography
              component="h4"
              variant="h4"
              width={"400px"}
              align="center"
            >
              {t("account:forgot_password").replace("?", "")}
            </Typography>
            <Box
              component="form"
              noValidate
              width={"400px"}
              onSubmit={handleSubmit}
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                type={"email"}
                placeholder={t("account:enter_email").toString() + " *"}
                value={email}
                autoFocus
                style={{ marginBottom: "20px" }}
                onChange={(e) => {
                  setEmail((e.target as HTMLInputElement).value);
                }}
              ></TextField>
              <ReCAPTCHA
                className="captcha-box"
                sitekey={GOOGLE_CAPTCHA_ID}
                onChange={onCaptchaDone}
                style={{
                  width: "100%",
                  backgroundColor: "#f5f5f5",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
              />
              <Button
                disabled={!enableSubmit}
                type="submit"
                fullWidth
                onClick={handleSubmit}
                variant="contained"
                sx={{ mt: 3, mb: 2, backgroundColor: purpleCTA }}
              >
                {t("account:send_confirm_email").toString()}
              </Button>
              <Grid container>
                <Grid item>
                  <Link href="/register" variant="body2">
                    {t("account:ask_for_sign_up").toString()}
                  </Link>
                </Grid>
              </Grid>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
export default ForgotPasswordPage;
